import React from "react";
import Layout from "../components/layout";

const About = () => (
  <Layout title="About">
    <div id="aboutPage">
      <section className="section mission">
        <div className="container">
          <div className="columns">
            <div className="column is-9 is-offset-1">
              <h2 className="has-text-weight-bold has-text-centered is-size-3">Mission</h2>
              <p className="is-size-4 missionDesc">
                DripStat has a simple, but ambitious goal – <span style={{ fontWeight: "bold" }}>to help you make better software.</span>
                <br />
                <br />
                Our service helps you analyze every little aspect of your software. It helps not just to spot performance problems, but also to debug errors, make better architectural decisions, save
                on infrastructure and development costs. Better software results in you ultimately being able to better serve your customers.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section funding grayBottomBorder">
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column is-offset-1">
              <h4>Building for the long term</h4>
            </div>
            <div className="column vc">
              <div className="is-uppercase has-text-weight-bold" style={{ marginBottom: "2rem" }}>
                Venture Capital Raised - $0
              </div>
              <div>
                Although we are located in Silicon Valley, we don’t want to play the typical Silicon Valley game. Remaining bootstrapped has allowed us to build a company for the long term. It allows
                us to make the best product for our customers and deliver it at the best possible price. We don’t force you to lock into any annual contracts and you don’t need to haggle with sales
                people to buy our product.
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section bizValues grayBottomBorder">
        <div className="container">
          <div className="columns">
            <div className="column has-text-centered">
              <h4 className="is-uppercase">Our Values</h4>
            </div>
          </div>

          <div className="columns is-variable is-8" style={{ marginBottom: "3rem" }}>
            <div className="column">
              <div className="bizVal">
                <img alt="" src="img/about/about1.png" style={{ width: "50px", height: "50px" }} />
                <div className="valueTitle">Product First</div>
                <div className="valueDesc">
                  We let our product do the talking. Most companies pour majority of their budget into Sales and Marketing. We put it in our product. We believe products are what companies should
                  produce, not ads for the product.
                </div>
              </div>
            </div>
            <div className="column">
              <div className="bizVal">
                <img alt="" src="img/about/about2.png" style={{ width: "74px", height: "50px" }} />
                <div className="valueTitle">Epic Support</div>
                <div className="valueDesc">
                  Our customers use us to monitor their critical business infrastructure. They can rely on having their back at all times. All our paid plans come with 24x7 support. You can even
                  directly get in touch with the engineering team through our support.
                </div>
              </div>
            </div>
          </div>
          <div className="columns is-variable is-8" style={{ marginBottom: "3rem" }}>
            <div className="column">
              <div className="bizVal">
                <img alt="" src="img/about/about3.png" style={{ width: "33px", height: "50px" }} />
                <div className="valueTitle">No Haggling With Sales</div>
                <div className="valueDesc">
                  No one like haggling with a sales person or being forced to sign annual contracts. We offer pay-as-you-go pricing plans so you can start using DripStat without talking to anyone.
                  That said, we do recognize that large enterprises do require a human to go through their complex purchase processes, and we do offer an account manager in those cases if needed.
                </div>
              </div>
            </div>

            <div className="column">
              <div className="bizVal">
                <img alt="" src="img/about/about4.png" style={{ width: "67px", height: "39px" }} />
                <div className="valueTitle" style={{ marginTop: "11px" }}>
                  By Developers, For Developers
                </div>
                <div className="valueDesc">
                  Our product is ultimately used by software developers. Being software developers ourselves, we have designed the entire experience of DripStat, from product, to support, to
                  purchasing, to be developer friendly.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section contact">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-3">
              <h4 className="is-uppercase">Contact us</h4>
              <p>
                989 E Hillsdale
                <br />
                Suite 200
                <br />
                Foster City, CA 94404
                <br />
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </Layout>
);

export default About;
